import {
  dashboardIcon,
  walletIcon,
  fileIcon,
  savingsIcon,
  teamsIcon,
  loanIcon,
  dashboardActiveIcon,
  walletActiveIcon,
  fileActiveIcon,
  savingsActiveIcon,
  teamsActiveIcon,
  loanActiveIcon,
  adminDashboardIcon,
  recordsIcon,
  investmentsIcon,
  wrench,
} from '@/assets';

export const studentNavigation = [
  {
    title: 'Dashboard',
    path: '/portal/dashboard',
    icons: { inactive: dashboardIcon, active: dashboardActiveIcon },
  },

  {
    title: 'Wallet',
    path: '/portal/wallet',
    icons: { active: walletActiveIcon, inactive: walletIcon },
  },

  {
    title: 'Finance',
    path: '#', //TODO:/portal/finance
    icons: { active: walletActiveIcon, inactive: loanIcon },
    children: [
      {
        title: 'Loans',
        path: '/portal/loans',
        icons: { active: loanActiveIcon, inactive: loanIcon },
      },
      {
        title: 'Savings',
        path: '/portal/savings',
        icons: { active: savingsActiveIcon, inactive: savingsIcon },
      },
    ],
  },

  {
    title: 'Land Pay',
    path: '/portal/my-slot',
    icons: { active: loanActiveIcon, inactive: loanIcon },
  },

  {
    title: 'Real Estate Market',
    path: '/portal/real-estate',
    icons: { active: loanActiveIcon, inactive: loanIcon },
  },

  {
    title: 'My Properties',
    path: '/portal/my-properties',
    icons: { active: loanActiveIcon, inactive: loanIcon },
  },
  {
    title: 'Sale Requests',
    path: '/portal/sale-requests',
    icons: { active: loanActiveIcon, inactive: loanIcon },
  },

  {
    title: 'Project Unit (APU)',
    path: '/portal/project-unit-market',
    icons: { active: fileActiveIcon, inactive: fileIcon },
  },

  {
    title: 'Project Slots (APS)',
    path: '/portal/project-slots',
    icons: { active: fileActiveIcon, inactive: fileIcon },
  },

  {
    title: 'My Slot',
    path: '/portal/my-project-slots',
    icons: { active: loanActiveIcon, inactive: loanIcon },
  },

  {
    title: 'My Team',
    path: '/portal/my-team',
    icons: { active: teamsActiveIcon, inactive: teamsIcon },
  },
];

export const adminNavigation = [
  {
    title: 'Dashboard',
    path: '/admin/dashboard',
    icon: adminDashboardIcon,
  },
  {
    title: 'Users',
    path: '/admin/users',
    icon: recordsIcon,
  },
  {
    title: 'Transactions',
    path: '/admin/transactions',
    icon: recordsIcon,
  },

  {
    title: 'Projects',
    path: '/admin/investments',
    icon: investmentsIcon,
  },

  {
    title: 'Real Estate',
    path: '/admin/real-estate',
    icon: investmentsIcon,
  },
  {
    title: 'Real Estate User Requests',
    path: '/admin/real-estate/user-requests',
    icon: investmentsIcon,
  },
  {
    title: 'Sale Requests',
    path: '/admin/sale-requests',
    icon: investmentsIcon,
  },
  {
    title: 'Mentorship',
    path: '/admin/mentorship',
    icon: recordsIcon,
  },
  {
    title: 'Loans',
    path: '/admin/loans',
    icon: recordsIcon,
  },
  {
    title: 'Cashout',
    path: '/admin/cashout',
    icon: recordsIcon,
  },
  {
    title: 'Config',
    path: '/admin/config',
    icon: wrench,
  },
  {
    title: 'Awap Project Unit (APU)',
    path: '/admin/project-unit',
    icon: investmentsIcon,
  },
  {
    title: 'Project Slots (APS)',
    path: '/admin/project-slots',
    icon: investmentsIcon,
  },
  {
    title: 'Activity Logs',
    path: '/admin/activities',
    icon: investmentsIcon,
  },
  {
    title: 'KYC',
    path: '/admin/kyc',
    icon: investmentsIcon,
  },
];

export const cardContent = [
  {
    id: 'promotional-balance',
    title: 'Reserved Capital',
    amount: '₦0',
    color: '#1565C0',
  },
  {
    id: 'cashout-balance',
    title: 'Main Wallet',
    amount: '₦0',
    color: '#699635',
  },
  {
    id: 'Savings',
    title: 'Savings',
    amount: '₦0',
    color: '#5615DE',
  },
  {
    id: 'matured-investments',
    title: 'Loans',
    amount: '₦0',
    color: '#CB0CCF',
  },
];

export const adminCardContent = [
  {
    id: 'active-users',
    title: 'Active Users',
    color: '#1565C0',
  },
  {
    id: 'mentorship-applications',
    title: 'Mentorship Applications',
    color: '#699635',
  },
  {
    id: 'completed-transactions',
    title: 'Completed Transactions',
    color: '#5615DE',
  },
  {
    id: 'running-investments',
    title: 'Running Projects',
    color: '#CB0CCF',
  },
];

export const lineData = {
  labels: [], //['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'],
  datasets: [
    {
      // label: 'Investments',
      data: [], //[450, 380, 750, 125, 700, 750, 900, 800, 400, 950],
      fill: false,
      backgroundColor: 'rgba(8, 91, 197, 0.6)',
      borderColor: 'rgba(8, 91, 197, 0.6)',
      borderWidth: 2,
    },
  ],
};
